(function() {
    let viewport = null;
    let frame = null;

    window.addEventListener('message', onMessageReceived);

    function onMessageReceived(e) {
        if (
            !e.data ||
            e.data.combinr !== true ||
            e.data.action !== 'scroll'
        ) {
            return;
        }

        viewport = e.data.viewport;
        frame = e.data.frame;

        document.body.dispatchEvent(new Event('repositiondialog'));
    }

    document.addEventListener('alpine:init', () => {
        Alpine.data('checkoutPopup', () => {
            let self;
            let popup;

            return {
                visible: false,
                init() {
                    self = this;
                    popup = this.$el.querySelector('.popup');

                    document.body.addEventListener(
                        'repositiondialog',
                        this.onPositionUpdate,
                    );
                },
                toggle() {
                    this.visible = !this.visible;

                    requestAnimationFrame(self.onPositionUpdate);
                },
                onPositionUpdate() {
                    if (!self.visible || viewport == null || frame == null) {
                        return;
                    }

                    const targetHeight = popup.clientHeight;

                    let center = (viewport.height / 2) -
                        frame.offsetTop +
                        viewport.scrollTop -
                        (targetHeight / 2);

                    const top = clamp(
                        center,
                        24,
                        document.body.scrollHeight - targetHeight - 24,
                    );

                    popup.style.top = `${top}px`;
                },
            };
        });
    });

    function clamp(value, min, max) {
        return value < min
            ? min
            : value > max
                ? max
                : value;
    }
}());

//# sourceMappingURL=checkout-popup.js.map
